import React from 'react';
import {ISelectProps, SelectInput} from '~/components/Controls/Select';
import {FormField, hasError, IFieldProps, onChangeField} from '~/components/Form';
import {Intent} from '~/lib/intent';
import {bidderEncodings} from '~/modules/Bidders/models/Bidder';

type ISelectBidderEncodingProps = Omit<ISelectProps<string>, 'items'>;

export const SelectBidderEncoding = (props: ISelectBidderEncodingProps) => (
    <SelectInput {...props}
        items={bidderEncodings.map(encoding => ({
            label: encoding,
            value: encoding
        }))}/>
);

export const SelectBidderEncodingField = (props: IFieldProps<ISelectBidderEncodingProps>) => <FormField {...props}>
    <SelectBidderEncoding {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;
